import { Boat, MapPin, ArrowRight, Clock } from '@phosphor-icons/react'
import { formatDateBR } from '../../lib/date'

export interface RouteLeg {
  port: string
  country: string
  eta?: string | null
  etd?: string | null
}

interface Props {
  freeTimeDays?: number | null
  carrierName?: string | null
  routeType?: 'direct' | 'transshipment' | null
  routeLegs?: RouteLeg[] | null
  compact?: boolean
}

export function RoutingInfo({
  freeTimeDays,
  carrierName,
  routeType,
  routeLegs,
  compact = false,
}: Props) {
  const hasAny = freeTimeDays || carrierName || routeType
  if (!hasAny) return null

  return (
    <div className={compact ? '' : 'space-y-3'}>
      <div className={`grid grid-cols-2 gap-3 text-sm`}>
        {carrierName && (
          <div className="flex items-start gap-2">
            <Boat size={16} className="text-gray-400 mt-0.5" />
            <div>
              <p className="text-xs text-gray-500">Armador</p>
              <p className="font-medium text-gray-900">{carrierName}</p>
            </div>
          </div>
        )}
        {freeTimeDays != null && (
          <div className="flex items-start gap-2">
            <Clock size={16} className="text-gray-400 mt-0.5" />
            <div>
              <p className="text-xs text-gray-500">Free Time</p>
              <p className="font-medium text-gray-900">{freeTimeDays} dias</p>
            </div>
          </div>
        )}
        {routeType && (
          <div className="flex items-start gap-2 col-span-2">
            <MapPin size={16} className="text-gray-400 mt-0.5" />
            <div className="flex-1">
              <p className="text-xs text-gray-500">Rota</p>
              <p className="font-medium text-gray-900">
                {routeType === 'direct' ? 'Direta (sem transbordo)' : 'Com transbordo'}
              </p>
            </div>
          </div>
        )}
      </div>

      {routeType === 'transshipment' && routeLegs && routeLegs.length > 0 && (
        <div className="mt-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
            Portos no caminho
          </p>
          <div className="flex flex-wrap items-center gap-2 text-sm">
            {routeLegs.map((leg, idx) => (
              <div key={idx} className="flex items-center gap-2">
                <div className="px-2 py-1 bg-white border border-gray-200 rounded">
                  <span className="font-medium text-gray-900">{leg.port}</span>
                  {leg.country && <span className="text-gray-500">, {leg.country}</span>}
                  {(leg.eta || leg.etd) && (
                    <div className="text-[10px] text-gray-500 mt-0.5">
                      {leg.eta && <span>ETA {formatDateBR(leg.eta)}</span>}
                      {leg.eta && leg.etd && <span> · </span>}
                      {leg.etd && <span>ETD {formatDateBR(leg.etd)}</span>}
                    </div>
                  )}
                </div>
                {idx < routeLegs.length - 1 && (
                  <ArrowRight size={14} className="text-gray-400" />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
